import '../Assests/css/views/json.css';
import '../Assests/css/components/jsoncard.css';

export default function ExploringCard() {
    return (
        <div className="json-card">
            <div className="json-card-header">
                <span className="json-card-dot red"></span>
                <span className="json-card-dot yellow"></span>
                <span className="json-card-dot green"></span>
                <span className="json-card-filename">currently_learning.json</span>
            </div>
            <div className="json-card-body">
                <pre className="json-payload">
<span className="json-brace">{"{"}</span>{"\n"}
{"  "}<span className="json-key">"currently_learning"</span><span className="json-colon">: </span><span className="json-bracket">[</span>{"\n"}
{"    "}<span className="json-string">"React JS "</span><span className="json-comma">,</span>{"\n"}
{"    "}<span className="json-string">"CQRS Architecture"</span><span className="json-comma">,</span>{"\n"}
{"    "}<span className="json-string">"Systems Design"</span><span className="json-comma">,</span>{"\n"}
{"    "}<span className="json-string">"Azure Stack"</span>{"\n"}
{"  "}<span className="json-bracket">]</span>{"\n"}
<span className="json-brace">{"}"}</span>
                </pre>
            </div>
        </div>
    );
}
